// extracted by mini-css-extract-plugin
export default {"header":"OtherExpenses_header__9Sh-V"};